import { updateOfficeBrand } from "../../../../../actions/Utilities/OfficeBrand";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "../../../../../components/toastNotification";

const useUpdateOfficeBrand = () => {
  return useMutation(updateOfficeBrand);
};
export default useUpdateOfficeBrand;
